import { Form, Input, Select } from "antd";
import { AiFillMinusCircle, AiFillPlusCircle } from "react-icons/ai";
import { TAGS } from "@lhd/features/Apps/AppForm/constants";
import styled from "styled-components";

export const Styles = styled.div`
  .label {
    margin-top: 1rem;
  }
  .inner {
    display: flex;
    flex-direction: column;
    .item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 5px 0px;
      .left-handle {
        display: flex;
        align-items: center;
        svg {
          margin: 0px 10px;
        }
      }
    }
  }
`;

const queryOptions = [
  {
    label: "網羅",
    value: "cont",
  },
  {
    label: "does not contain",
    value: "not_cont",
  },
  {
    label: "= (equal to)",
    value: "eq",
  },
  {
    label: "≠ (not equal to)",
    value: "not_eq",
  },
  {
    label: "≦ (less than or equal to)",
    value: "lteq",
  },
  {
    label: "≧ (greater than or equal to)",
    value: "gteq",
  },
];

const filterOptions = [{ label: "全てレコード", value: "all_records" }].concat(
  TAGS.map((tag) => ({
    label: tag.name,
    value: tag.app_part_type,
  })),
);

const InitialFilterSetting = () => {
  return (
    <Styles>
      <div className="label">初期フィルター設定</div>
      <Form.List name="initial_filters" initialValue={[{}]}>
        {(fields: any[], { add, remove }: any) => (
          <div className="inner">
            {fields.map(({ key, name, ...restField }, index) => (
              <div className="item" key={key}>
                <div className="left-handle">
                  <Form.Item
                    name={[name, "filter"]}
                    initialValue={filterOptions[0]}
                  >
                    <Select options={filterOptions} style={{ width: 300 }} />
                  </Form.Item>
                  <Form.Item
                    name={[name, "query"]}
                    initialValue={queryOptions[0]}
                  >
                    <Select options={queryOptions} />
                  </Form.Item>
                  <Form.Item>
                    <Input />
                  </Form.Item>
                </div>
                <div>
                  <AiFillPlusCircle
                    color="#ababab"
                    size={18}
                    onClick={() => add("add", index)}
                  />
                  {fields.length !== 1 && (
                    <AiFillMinusCircle
                      color="#ababab"
                      size={18}
                      onClick={() => remove(index)}
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </Form.List>
    </Styles>
  );
};

export default InitialFilterSetting;
